import { Skeleton } from "baseui/skeleton";
import { Notification, KIND } from "baseui/notification";

export interface LoadingViewProps {
  children: any;
  error?: any;
  isLoading: boolean;
  isSucess: boolean;
  width?: string;
  lines?: number;
}

const notifFullWidth = {
  Body: {
    style: ({ $theme }) => ({
      width: "100%",
    }),
  },
};

const LoadingView = (props: LoadingViewProps) => {
  if (props.error) {
    if (props.error.status === 401 || props.error.originalStatus === 401)
      return (
        <Notification overrides={notifFullWidth} kind={KIND.negative}>
          <b>Access was denied </b>
          <br />
          <br />
          {props.error.data.message}
        </Notification>
      );
    if (props.error.status === 500 || props.error.originalStatus === 500)
      return (
        <Notification overrides={notifFullWidth} kind={KIND.negative}>
          <b>Internal error in backend</b>
          <br />
          <br />
          {props.error?.data?.message}
        </Notification>
      );
    return (
      <Notification overrides={notifFullWidth} kind={KIND.negative}>
        There has been an error loading data
        <br />
        <br />
        {JSON.stringify(props.error)}
      </Notification>
    );
  }
  if (props.isSucess) {
    const c = props.children;
    return <>{c}</>;
  }
  if (props.isLoading) {
    return (
      <Skeleton
        animation
        rows={props.lines ?? 3}
        width={props.width || "100%"}
        overrides={{
          Row: {
            style: {
              height: "20px",
              marginBottom: "15px",
            },
          },
        }}
      />
    );
  }
  return <></>;
};

export default LoadingView;
